// extracted by mini-css-extract-plugin
export default {"empty":"fPIdyctNkQMAaUHH9p3O","common_bganimation":"h3p03RQaQg9c51ZlBN9d"};